import React from 'react';
import { SilhouetteType } from '../data/products';
import { WomenShapewearIcon, MenShapewearIcon, FoamIcon, GelIcon, BeltIcon } from './icons';
interface PlaceholderImageProps {
  silhouette: SilhouetteType;
  className?: string;
}
export const PlaceholderImage: React.FC<PlaceholderImageProps> = ({
  silhouette,
  className = ''
}) => {
  const getIcon = () => {
    switch (silhouette) {
      case 'faja':
        return <WomenShapewearIcon className="w-full h-full" data-id="element-326" />;
      case 'boxer':
        return <MenShapewearIcon className="w-full h-full" data-id="element-327" />;
      case 'board':
      case 'pillow':
      case 'wrap':
        return <FoamIcon className="w-full h-full" data-id="element-328" />;
      case 'gel':
      case 'tea':
      case 'soap':
        return <GelIcon className="w-full h-full" data-id="element-329" />;
      case 'corset':
      case 'bra':
      case 'panty':
      case 'sleeve':
      case 'mask':
        return <BeltIcon className="w-full h-full" data-id="element-330" />;
      default:
        return <WomenShapewearIcon className="w-full h-full" data-id="element-331" />;
    }
  };
  return <div className={`bg-[#F5EFE6] flex items-center justify-center text-gold/20 ${className}`} data-id="element-332">
      <div className="w-1/2 h-1/2" data-id="element-333">{getIcon()}</div>
    </div>;
};